import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Add as AddIcon, Close as CloseIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import {useState} from 'react'
import {useFragment} from 'react-relay'

import MSTeamsProviderLogo from '../../../../components/MSTeamsProviderLogo'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps, {} from '../../../../hooks/useMutationProps'
import {Providers} from '../../../../types/constEnums'
import MSTeamsConfigMenu from './MSTeamsConfigMenu'
import MSTeamsPanel from './MSTeamsPanel'
import ProviderRow from './ProviderRow'






graphql`
  fragment MSTeamsProviderRowTeamMemberIntegrations on TeamMemberIntegrations {
    msTeams {
      auth {
        provider {
          id
        }
      }
      teamNotificationSettings {
        ...NotificationSettings_settings
      }
    }
  }
`
const MSTeamsProviderRow = (props) => {
  const {viewerRef, teamId} = props
  const viewer = useFragment(
    graphql`
      fragment MSTeamsProviderRow_viewer on User {
        ...MSTeamsPanel_viewer
        teamMember(teamId: $teamId) {
          integrations {
            ...MSTeamsProviderRowTeamMemberIntegrations @relay(mask: false)
          }
        }
      }
    `,
    viewerRef
  )
  const [isConnectClicked, setConnectClicked] = useState(false)
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)
  const {submitting, submitMutation, error, onError, onCompleted} = useMutationProps()
  const mutationProps = {submitting, submitMutation, onError, onCompleted} 
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {msTeams} = integrations
  const {auth} = msTeams

  if (window.__ACTION__.msTeamsDisabled) return null

  return (
    _jsxs(_Fragment, { children: [
      _jsx(ProviderRow, {
        connected: !!auth,
        onConnectClick: () => setConnectClicked(!isConnectClicked),
        submitting: submitting,
        togglePortal: togglePortal,
        menuRef: originRef,
        providerName: Providers.MSTEAMS_NAME,
        providerDescription: Providers.MSTEAMS_DESC,
        providerLogo: _jsx(MSTeamsProviderLogo, {} ),
        connectButtonText: !isConnectClicked ? 'Connect' : 'Cancel',
        connectButtonIcon: !isConnectClicked ? _jsx(AddIcon, {} ) : _jsx(CloseIcon, {} ),
        error: _optionalChain([error, 'optionalAccess', _ => _.message]),
 children: 
        (auth || isConnectClicked) && _jsx(MSTeamsPanel, { teamId: teamId, viewerRef: viewer,} )
      })
      , auth &&
        menuPortal(
          _jsx(MSTeamsConfigMenu, {
            menuProps: menuProps,
            mutationProps: mutationProps,
            providerId: auth.provider.id,}
          )
        )
    ]})
  )
}

export default MSTeamsProviderRow
